import React, { useEffect } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import styled from 'styled-components';
import Swal from 'sweetalert2';

import { timestampToDate } from '../../helpers/TimestampToDate';
import ApiService from '../../helpers/ApiService';
import { useAuth } from '../../providers/AuthProvider';
import { useCode } from '../../providers/CodeProvider';
import { Title } from '../Common/Title';

const CouponsTableContainer = styled.div`
  /* background-color: var(--secondary); */
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 2rem;

  .MuiTable-root {
    background-color: var(--tertiary);
    border-radius: 0.5rem;
  }
  .MuiTableCell-root {
    color: var(--white);
    border-bottom-color: var(--tertiary-dark);
  }
`;

const CustomTableContainer = styled(TableContainer)`
  & th:first-of-type {
    border-radius: 1rem 0 0 0;
  }
  & th:last-of-type {
    border-radius: 0 1rem 0 0;
  }
  & tr th {
    font-family: 'GothamBold' !important;
  }
  & tr:last-of-type {
    & td {
      border-bottom: unset;
    }
    & td:first-child {
      border-radius: 0 0 0 1rem;
    }
    & td:last-child {
      border-radius: 0 0 1rem 0;
    }
  }
`;

export const CouponsTable = () => {
  const { token } = useAuth();
  const { codeNumbers, setCodeNumbers } = useCode();
  let lineNumber = 0;

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if(token !== "") {
        ApiService.get('code/numbers', token).then((result) => {
          if(result.status === 200) {
            setCodeNumbers(result.data.codes);
          }
        }).catch((error) => {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Ocorreu um erro desconhecido. Tente novamente mais tarde.',
            confirmButtonText: "Entendi"
          });
        });
      }
    }

    return () => mounted = false;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const createLine = ( createdAt, code, luckyNumber, bg = "" ) => {
    lineNumber++;
    return (
      <TableRow key={`row${lineNumber}`} style={{ backgroundColor: bg }}>
        <TableCell>{lineNumber}</TableCell>
        <TableCell>{timestampToDate(createdAt, true, " ")}</TableCell>
        <TableCell>{code}</TableCell>
        <TableCell>{luckyNumber}</TableCell>
      </TableRow>
    )
  }

  const completeLuckyNumber = (serie, code) => {
    const tempSerie = String(serie).padStart(2, "0");
    const tempCode = String(code).padStart(5, "0");
    return `${tempSerie}.${tempCode}`;
  }

  const validateCode = (createdAt) => {
    return ( createdAt + (48*60*60*1000) > new Date().getTime() )
  }

  return (
    <CouponsTableContainer>
      {codeNumbers && codeNumbers.length > 0 ? (
        <>
          <Box mb={3}>
            <Title>Estes são seus números da sorte</Title>
          </Box>
          <CustomTableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Nº</TableCell>
                  <TableCell>Data de resgate</TableCell>
                  <TableCell>Código cadastrado</TableCell>
                  <TableCell>Número da sorte</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {codeNumbers && codeNumbers.map((rescuedCoupon) => (
                  <React.Fragment key={`id${Math.random()}`}>
                    {rescuedCoupon.luckyNumbers.length === 0 && createLine( rescuedCoupon.createdAt, rescuedCoupon.code, validateCode(rescuedCoupon.createdAt) ? "Ainda não disponível" : "Código inválido", !validateCode(rescuedCoupon.createdAt) && "var(--orange-400)" ) }
                    {rescuedCoupon.luckyNumbers && rescuedCoupon.luckyNumbers.map(( luckyCoupon ) => createLine( rescuedCoupon.createdAt, rescuedCoupon.code, completeLuckyNumber(luckyCoupon.serie, luckyCoupon.code), "var(--orange-300)" ) )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </CustomTableContainer>
        </>
      ) : (
        <Typography variant="h5" className='middle--text' align='center'>
          Você ainda não possui números da sorte
        </Typography>
      )}
    </CouponsTableContainer>
  )
}
